module.exports = __webpack_public_path__ + "img/Delete.6a235ee0.svg";